// extracted by mini-css-extract-plugin
export default {"InfoList":"InfoList_InfoList__SBxSU","head":"InfoList_head__U2BSC","name":"InfoList_name__2WRt8","date":"InfoList_date__MM70D","container":"InfoList_container__oNKh3"};